import { ClipControls } from "../../parameterWidgets/ClipControls";
import { ColorCodeSelector, PianoRoll } from "../../parameterWidgets/PianoRoll";
import { GrufModulEQ, GrufModulSends } from "../../components/moduls";
import { ParameterKnob } from "../../parameterWidgets/ParameterKnob";
import SeparatorLine from "jsx:$assets/widgets/separator_line.svg";
import { HelpBox } from "../../components/HelpBox";
import { PresetBankBar } from "../../parameterWidgets/PresetBankBar";


export const PianoWamUI = ({instrument}) => {

    return (<div className="estacio estacio-piano" style={{"--accent-color": instrument.metadata.color}}>
        <PresetBankBar instrument={instrument} />
        <div className="modul-border modul-bg flex justify-between items-center">
            <ParameterKnob data-widget-id="instrumentVolume" mida="gran" parameterHandler={instrument.getParameterHandler("gain")} />
            <SeparatorLine className="h-full"/>
            <ParameterKnob data-widget-id="pianoSound" mida="gran" parameterHandler={instrument.getParameterHandler("sound")} />
        </div>
        <GrufModulEQ instrument={instrument} />
        <GrufModulSends instrument={instrument} className="square" />
        <HelpBox className="row-span-2" instrument={instrument} />

        <PianoRoll className="row-span-5" instrument={instrument} colorNotes={instrument.metadata.color} />
        <div className="flex gap-10 justify-between align-center">
            {instrument.getParameterDescription("pianoRollColorCode") && <ColorCodeSelector instrument={instrument}/>}
            <ClipControls className="contents" instrument={instrument} showAutogenerate/>
        </div>
    </div>)
};